import * as v2 from '@/core/services/api/v2';

const state = {
  announcements: [], // Ensure it's initialized as an empty array
  loading: false,
  error: null
};

const getters = {
  sortedAnnouncements: state => state.announcements || [] // Add defensive check
};

const mutations = {
  SET_ANNOUNCEMENTS(state, announcements) {
    state.announcements = announcements;
  },
  ANNOUNCEMENTS_SET_LOADING(state, status) {
    state.loading = status;
  },
  SET_ERROR(state, error) {
    state.error = error;
  }
};

const actions = {
  async fetchAnnouncements({ commit }) {
    commit('ANNOUNCEMENTS_SET_LOADING', true);
    commit('SET_ERROR', null);
    
    try {
      // O caminho é o mesmo do Strapi (`/api/announcement/desc`) porque o V2 o
      // manteve de propósito, para não exigir subir os dois repositórios no
      // mesmo minuto. A rota é pública: a Home aparece antes do login.
      const announcements = (await v2.anuncios()) || [];
      commit('SET_ANNOUNCEMENTS', announcements);
    } catch (error) {
      console.error('Error fetching announcements:', error);
      commit('SET_ERROR', error.message);
      commit('SET_ANNOUNCEMENTS', []); // Reset to empty array on error
    } finally {
      commit('ANNOUNCEMENTS_SET_LOADING', false);
    }
  }
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
